import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import React, { useState, FC } from 'react';
import DashboardModal from '../../Modals/DashboardModal/dashboardModal';
import AddIndicatorButtonStyled from './styled';

interface AddIndicatorButtonProps {
    label: string;
    rankingParameter: { columnToApply: number, rankToApply: number };
}

const AddIndicatorButton: FC<AddIndicatorButtonProps> = ({ label, rankingParameter }) => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <AddIndicatorButtonStyled
                onClick={() => setOpenModal(true)}
                startIcon={<ControlPointOutlinedIcon />}
                disableRipple
            >
                {label}
            </AddIndicatorButtonStyled>
            <DashboardModal openModal={openModal} rankingParameter={rankingParameter} setOpenModal={setOpenModal} />
        </>
    );
};

export default AddIndicatorButton;
